import { create } from 'zustand';

/**
 * Post Modal Store
 * Manages the state for the PostModal component across the app
 */
export const usePostModalStore = create((set) => ({
  // State
  post: null,
  isOpen: false,

  // Actions
  openModal: (post) =>
    set({
      post,
      isOpen: true,
    }),

  closeModal: () =>
    set({
      post: null,
      isOpen: false,
    }),

  setPost: (post) =>
    set({
      post,
    }),
}));
